import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../state/actions';
import Layout from '../../components/layout/Layout';
import PreloaderBg from '../../components/shared/preloaderBg/PreloaderBg';
import MenuLeftProfilo from '../../components/shared/menuLeftProfilo/MenuLeftProfilo';
import OrdersDetail from '../../components/profile/ordersDetail/OrdersDetail';
import BloccoProfiloMenuLeft from '../../components/shared/bloccoProfiloMenuLeft/BloccoProfiloMenuLeft';

const Orders = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const currentPage = useSelector((state) => state.currentPage);
	const staticPages = useSelector((state) => state.staticPages);
	const user = useSelector((state) => state.user);
	const isFetching = currentPage.isFetching;

	useEffect(() => {
		// controllo nello store se ho già il dettaglio della pagina ordini, altrimenti eseguo action creator
		const ordersPage = staticPages.orders;

		if (ordersPage === undefined || ordersPage.detail === undefined) {
			// non ho i dati nello store, chiamo action creator fetchOrdersDetail
			setTimeout(
				() =>
					dispatch(
						allActions.profileDetailActions.fetchOrdersDetail(
							currentPage.currentLang,
							user.token_id,
							user.userData.id
						)
					),
				50
			);
		} else {
			// loading...
			dispatch(allActions.isFetchingAction.loadStoredData());

			// recupero dati da store
			dispatch(allActions.profileDetailActions.loadOrdersDetail(ordersPage));
		}

		//console.log(ordersPage);
	}, [location]);

	return (
		<Layout>
			<div className='container mx-auto'>
				<PreloaderBg showPreloader={isFetching} />
				<div className='grid grid-cols-60'>
					<MenuLeftProfilo />
					<OrdersDetail />
					<div className='col-span-60 flex lg:hidden'>
						<BloccoProfiloMenuLeft />
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default Orders;
